import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { FiltrosFluxoCaixaService } from '../../../../filters/filtros-fluxocaixa.service';
import { FluxocaixaService } from '../../../../services/fluxocaixa.service';
import { ToastService } from '../../../../services/toast.service';

@Component({
  selector: 'app-painelfluxocaixa',
  templateUrl: './painelfluxocaixa.component.html',
  styleUrl: './painelfluxocaixa.component.css',
  providers: [DatePipe]
})
export class PainelfluxocaixaComponent {
  rangeDates!: string;
  instanciaSelecionada!: string;
  loading: boolean = false;
  activeIndex: number = 0;

  constructor(
    private filtrosFluxoCaixa: FiltrosFluxoCaixaService,
    private datePipe: DatePipe,
    private fluxocaixaService: FluxocaixaService,
    private toastService: ToastService
  ){}

  onDateChange(event: any){
    this.filtrosFluxoCaixa.alteraDataInicio(this.getDataPipeTransForm(this.rangeDates[0]));
    this.filtrosFluxoCaixa.alteraDataFim(this.getDataPipeTransForm(this.rangeDates[1]));
  }

  onInstanciaChange(event: any){
    this.filtrosFluxoCaixa.alteraInstancia(this.instanciaSelecionada);
  }

  onChangeTab(event: any) {
    this.activeIndex = event.index;
  }

  exportar(){
    if (!this.instanciaSelecionada || !this.rangeDates || this.rangeDates.length < 2) {
      this.toastService.alerta("Exportar", "Selecione instância e período para exportar.");
      return;
    }

    this.loading = true;
    let dataInicio = this.getDataPipeTransForm(this.rangeDates[0]);
    let dataFim = this.getDataPipeTransForm(this.rangeDates[1]);

    let corpo = {
      instancia: this.instanciaSelecionada,
      dataInicio: dataInicio,
      dataFim: dataFim,
      usuario: localStorage.getItem("cdUsuarioErp")
    };

    let observable;
    let fileName = 'data.xlsx';

    if (this.activeIndex === 0) { // Despesas
       observable = this.fluxocaixaService.exportarDespesas(corpo);
       fileName = 'despesas.xlsx';
    } else if (this.activeIndex === 1) { // Receitas
       observable = this.fluxocaixaService.exportarReceitas(corpo);
       fileName = 'receitas.xlsx';
    } else if (this.activeIndex === 2) { // Custos
       observable = this.fluxocaixaService.exportarCustosCalculados(corpo);
       fileName = 'custos_calculados.xlsx';
    }

    if(observable) {
        observable.subscribe({
          next: (value: any) => {
            const url = window.URL.createObjectURL(value);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            this.loading = false;
          },
          error: (error: any) => {
             this.toastService.erro("Exportar", 'Erro ao exportar: ' + (error.error?.message || error.message || 'Erro desconhecido'));
             this.loading = false;
          }
        });
    } else {
        this.loading = false;
    }
  }

  getDataPipeTransForm(data: string): string | "" {
    return this.datePipe.transform(data,'yyyy-MM-dd') || "";
  }
}
